"use strict";

exports.__esModule = true;
exports.cssNumberMatcher = exports.alphaSeparatorMatcher = void 0;
exports.exact = exact;
exports.extractValuesFromMatch = extractValuesFromMatch;
exports.separatorMatcher = void 0;

function exact(regex) {
  return new RegExp("^" + regex.source + "$", regex.flags);
}

function extractValuesFromMatch(match) {
  return match.slice(1).filter(function (val) {
    return val !== undefined;
  });
}

var cssNumberMatcher = /[+-]?(?=\.\d|\d)\d*(?:\.\d+)?(?:[eE][+-]?\d+)?/;
exports.cssNumberMatcher = cssNumberMatcher;
var separatorMatcher = /(?=[,\s])\s*(?:,\s*)?/;
exports.separatorMatcher = separatorMatcher;
var alphaSeparatorMatcher = /\s*[,\/]\s*/;
exports.alphaSeparatorMatcher = alphaSeparatorMatcher;